import axiosInstance from "../../api/axiosInstance";

export const fetchRolesAPI = async () => {
  const response = await axiosInstance.get("roles/get-all-roles");
  return response.data;
};

export const createRoleAPI = async ({ role, permissions, canManageRoles }) => {
  const response = await axiosInstance.post("roles/create-role", {
    role,
    permissions,
    canManageRoles,
  });
  return response.data;
};

export const updateRoleAPI = async (roleId, changes) => {
  const response = await axiosInstance.put(`roles/update-role/${roleId}`, changes);
  return response.data;
};

export const deleteRoleAPI = async (roleId) => {
  const response = await axiosInstance.delete(`roles/delete-role/${roleId}`);
  return response.data;
};
